import Component from '@glimmer/component';

/**
 * @param {Array} items - Array to yield in <:items>. Each item will be pre-wrapped in a
 *                        WellItem. If items is empty, <:empty> will be rendered.
 */
// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class Well extends Component {}
